<script setup>
/**
 * FormControlActivityRowId
 * Fetches activity log data and initializes a read-only CodeMirror
 * instance to display the formatted JSON payload.
 */
import {ref, onMounted} from 'vue'
import FormControlPlainText from "./FormControlPlainText.vue"
import api from '@/services/api'

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: Number,
        default: null
    }
})

const codeMirror = ref(null)

/**
 * Fetches item data and initializes the CodeMirror editor
 */
const getItemData = async () => {
    try {
        const response = await api.get(`api/activity/${props.currentData.id}`)

        const indent = 2

        // Initialize CodeMirror using the global instance
        // Ensure CodeMirror scripts are loaded in the environment
        const editor = window.CodeMirror.fromTextArea(codeMirror.value, {
            mode: 'application/json',
            lineNumbers: true,
            lineWrapping: true,
            readOnly: true,
            indentUnit: indent,
            tabMode: 'spaces',
            enterMode: 'indent',
            electricChars: false
        })

        const data = response.data.item.data
        const json = JSON.stringify(data, undefined, indent)

        editor.getDoc().setValue(json)
    } catch (error) {
        console.error('Failed to load activity JSON data:', error)
    }
}

onMounted(() => {
    getItemData()
})
</script>

<template>
    <div>
        <FormControlPlainText :form-id="formId">
            {{ currentData[field.name] }}
        </FormControlPlainText>

        <textarea ref="codeMirror" style="display: none"></textarea>
    </div>
</template>

<style scoped>
/* CodeMirror styles usually need to be handled globally or imported */
:deep(.CodeMirror) {
    border: 1px solid #eee;
    height: auto;
    min-height: 200px;
}
</style>